import React from 'react';
import MuiNavbar from '../common/MuiNavbar';
import MuiFooter from '../common/MuiFooter';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * PublicLayout component that provides a layout for public pages
 * with navigation and footer using Material UI components for a corporate design.
 */
const PublicLayout = ({ children }) => {
  const theme = useTheme();
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          minHeight: '100vh',
          bgcolor: 'background.default'
        }}
      >
        <MuiNavbar />
        <Box 
          component="main" 
          sx={{ 
            flexGrow: 1,
            width: '100%'
          }}
        >
          {children}
        </Box>
        <MuiFooter />
      </Box>
    </ThemeProvider>
  );
};

export default PublicLayout; 